// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"News__Wrapper_1oLa9"};